import { CustomFilterField, CustomFilterType, CustomFilterOperator } from "../Models/CustomFilterModels";

export enum InfraFilter {
    All,
    OnlyBridges,
    OnlySignage
}

export enum InfraOrder {
    None,
    InfraTypeDescr,
    DateInstDescending,
    RiskProduct,
    AdminAreaDescr,
    InfraCode
}
